"use strict";
var $ = require("../internals/export");
var anObject = require("../internals/an-object");
var getOwnPropertyDescriptor = require("../internals/object-get-own-property-descriptor").f;
$({ target: "Reflect", stat: true }, {
  deleteProperty: function deleteProperty(target, propertyKey) {
    var descriptor = getOwnPropertyDescriptor(anObject(target), propertyKey);
    return descriptor && !descriptor.configurable ? false : delete target[propertyKey];
  }
});
